export default "__VITE_ASSET__LNjGzP27__"